import { SxProps, Theme } from '@mui/material'

/** Shared row divider for index components table body cells (matches pre-refactor ComponentView). */
export const indexComponentRowCellDividerSx: SxProps<Theme> = {
    borderBottom: 1,
    borderColor: 'divider',
}

export const indexComponentBodyCellSx: SxProps<Theme> = {
    py: 0.5,
    px: 1,
    ...indexComponentRowCellDividerSx,
}
